import React from 'react';
import { IconCircleCheck } from '@tabler/icons-react';
import { Alert } from 'reactstrap';

export default function SurveySuccess() {
    return (
        <Alert color="success" className="text-center">
            <IconCircleCheck size={80} stroke={1.5} className="text-success w-100 my-4" />
            <h1 className="alert-heading">Vielen Dank!</h1>
            <p>Die Antworten helfen uns bei der Verbesserung unserer Services.</p>
        </Alert>
    );
}
